import React from "react";
import { Avatar, Col, Row, Space } from "antd";
import './InfoCardComponent.scss';
import {InfoCardComponentTypes} from "./InfoCardComponent.types";

const InfoCardComponent = ({type, text, number}: InfoCardComponentTypes ) =>{
  return (
    <div className={`InfoCardComponent ${type ? type : "cardInfo"}`}>
      <Row wrap={false} justify="start">
        <Space>
          <Col>
            <Avatar className="InfoCardComponent cardInfoNumber">{number}</Avatar>
          </Col>
          <Col>
            <div className="InfoCardComponent cardInfoText"> {text} </div>
          </Col>
        </Space>
      </Row>
    </div>
  );
}
export default InfoCardComponent
